import type { DynamicTableColumnConfig } from '../config/types';
import { interpolateQuestionText } from './form-utils';

export const getDynamicTableColumnLabel = (
  column: DynamicTableColumnConfig,
  answers: Record<string, unknown>,
) => interpolateQuestionText(column.labelTemplate, answers) || column.label;
